import React, { Component } from 'react'
import * as func from "../../../utils/functions";
import {MESSAGE, EDIT_MODE} from "../../../wpconfig"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleDown, faEdit, faSave, faTimes, faCheckSquare, faTrashAlt, faGripVertical } from '@fortawesome/free-solid-svg-icons'

class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
			isEdit: this.props.record.is_edit ? EDIT_MODE.SHOW_EDIT : EDIT_MODE.SHOW,
			record : func.deepClone(this.props.record),
      isOpenChild : false,
			// name : '아이디',
      field : 'category',
			id : 'category_id',
			name : 'category_name',
	    pkKey : 'category_id',
		}
  }

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(this.props.index, this.props.record, true);
	}

	onEditSave = (event) => {
		event.preventDefault()

		let isEdit = '';
		if (this.state.isEdit === EDIT_MODE.SHOW) {
			isEdit = EDIT_MODE.SHOW_EDIT;
		} else if (this.state.isEdit === EDIT_MODE.SHOW_EDIT) {
			isEdit = EDIT_MODE.SAVE_EDIT;
		}

		if (isEdit === EDIT_MODE.SAVE_EDIT) {
			if (this.props.record[this.props.pkKey]) {
				func.updateData(this.state.field + "/update", this.props.record).then((response) => {
					if (response.code === 'ok') {
						isEdit = EDIT_MODE.SHOW;
						this.setState({record : func.deepClone(this.props.record)})
						this.props.showMessage('수정 되었습니다.');
					} else {
						this.props.showMessage('수정 실패 : ' + response.message)
						isEdit = EDIT_MODE.SHOW_EDIT;
					}
					this.setState({'isEdit': isEdit});
				});
			}
		} else {
			this.props.onEditIndex(this.props.index)
			this.setState({'isEdit': EDIT_MODE.SHOW_EDIT});
		}
	};

	onCloseDelete = (event) => {
		event.preventDefault()
		if (this.props.record[this.props.pkKey]) {
			if (this.state.isEdit) {
				this.setState({'isEdit': EDIT_MODE.SHOW});
				this.props.onUpdate(this.props.index, func.deepClone(this.state.record), true);
			} else {
				if (confirm(this.props.record[this.state.name] + '을(를) ' + MESSAGE.DELETE)) {
					let record = this.props.record;
					func.updateData(this.state.field + "/delete", record).then((response) => {
						if (response.code === 'ok') {
							this.props.showMessage('삭제 되었습니다.');
							this.props.onRemove(this.props.index)
						} else {
							this.props.showMessage('삭제 실패 : ' + response.message)
						}
					});
				}
			}
		} else {
			this.setState({'isEdit': EDIT_MODE.SHOW});
			this.props.onRemove(this.props.index)
		}
	}

	onClose = (e) => {
		this.setState({'isEdit': EDIT_MODE.SHOW});
		if (this.props.record[this.props.pkKey]) {
			this.props.onUpdate(this.props.index, func.deepClone(this.state.record), true);
		} else {
			this.props.onRemove(this.props.index)
		}
	};

  openChildNode = (e) => {
    e.preventDefault();

    this.setState(prevState => ({
      isOpenChild: !prevState.isOpenChild
    // }), () => {
    //   this.props.funOpenChild(this.state.isOpenChild)
    }))
  }

  render() {
    const { openChildNode, onEditSave, onCloseDelete } = this;

    return (
      <>
      {
        this.state.isEdit === EDIT_MODE.SHOW ? (
          <>
          <tr>
            <td className="catTitle">
              {/* <span className="dragSelector">
                <FontAwesomeIcon icon={faGripVertical} />
              </span> */}
              <ul className="catRow m-0">
                <li className="catOpener">
	                {this.props.record.depth_level === 1 &&
	                <button className="openButton" onClick={openChildNode}>
		                {
			                this.state.isOpenChild ? (
				                <FontAwesomeIcon icon={faAngleDown}/>
			                ) : (
				                <FontAwesomeIcon icon={faAngleRight}/>
			                )
		                }
	                </button>
	                }
                </li>
                <li>
                  <h5>
                    {this.props.record.category_name}
                  </h5>
                </li>
              </ul>
            </td>
            <td className="catSlug">
              <p>
                {this.props.record.slug}
              </p>
            </td>
            <td>
              <div className="btn-group">
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onEditSave}>
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCloseDelete}>
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              </div>
            </td>
          </tr>
          </>
        ) : (
          <>
          <tr>
            <td className="catTitle">
              {/* <span className="dragSelector">
                <FontAwesomeIcon icon={faGripVertical} />
              </span> */}
              <ul className="catRow m-0">
                <li className="catOpener">
                  <button className="openButton" onClick={openChildNode}>
                    {
                      this.state.isOpenChild ? (
                        <FontAwesomeIcon icon={faAngleDown} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleRight} />
                      )
                    }
                  </button>
                </li>
                <li>
                  <input 
                    type="text"
                    name="category_name"
                    value={this.props.record.category_name}
                    onChange={this.change}
                    />
                </li>
              </ul>
            </td>
            <td className="catSlug">
              <input 
                type="text"
                name="slug"
                value={this.props.record.slug}
                onChange={this.change}
                />
            </td>
            <td>
              <div className="btn-group">
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onEditSave}>
                  <FontAwesomeIcon icon={faSave} />
                </button>
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCloseDelete}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            </td>
            </tr>
          </>
        )
      }
      {
        this.state.isOpenChild &&
        this.props.record.children.length > 0 && (
          <tr>
            <td className={`depth2 pl-4 p-0 m-0`} colSpan={3}>
              <table className="table table-thin mb-0">
                <colgroup>
                  <col />
                  <col width="180px"/>
                  <col width="100px"/>
                </colgroup>
                <tbody>
                {
                  this.props.record.children.map((data, idx) => {
                    return (
                      <Item 
                        key={data[this.props.pkKey]}
                        index={data[this.props.pkKey]}
                        ref={"ref" + data[this.props.pkKey]}
                        arrIndex={idx}
                        pkKey={this.props.pkKey}
                        record={data}
                        funOpenChild={this.openChild}
                        onUpdate={this.onUpdate}
                        onRemove={this.onRemove}
                        onEditIndex={this.onEditIndex}
                        showMessage={this.showMessage}
                        />
                    )
                  })
                }
                </tbody>
              </table>
            </td>
          </tr>
        )
      }
      </>
    )
  }
}

export default Item;
